import React, { memo } from 'react';
import { Outlet } from 'react-router-dom';

function WarehouseOut() {
  return (
    <Outlet />
  );
}

export default memo(WarehouseOut);
